import React, { useLayoutEffect, useRef } from "react";
import { UnifiedPortfolioItem } from "@/types/unified-portfolio";
import UnifiedPortfolioCard from "./UnifiedPortfolioCard";

interface UnifiedPortfolioListProps {
  items: UnifiedPortfolioItem[];
  onRemove: (id: string) => void;
  onEdit: (id: string) => void;
  onRename: (id: string, newTitle: string) => void;
  onSetFeatured: (id: string) => void;
  onUpdateStatus: (id: string, status: "draft" | "published") => void;
  onDuplicate: (id: string) => void;
  onPreview?: (item: UnifiedPortfolioItem) => void;
  sortOrder: 'last_added' | 'last_edited' | 'alphabetical' | 'featured_first' | 'most_viewed';
  isProcessing?: boolean;
}

// Use the component directly without memoization for now
const MemoUnifiedPortfolioCard = UnifiedPortfolioCard;

const UnifiedPortfolioList: React.FC<UnifiedPortfolioListProps> = ({
  items,
  onRemove,
  onEdit,
  onRename,
  onSetFeatured,
  onUpdateStatus,
  onDuplicate,
  onPreview,
  sortOrder,
  isProcessing = false,
}) => {
  console.log('UnifiedPortfolioList - onRemove function:', onRemove);
  const gridRef = useRef<HTMLDivElement>(null);
  const [isTransitioning, setIsTransitioning] = React.useState(false);

  // Handle smooth transitions when items change
  useLayoutEffect(() => {
    if (gridRef.current) {
      setIsTransitioning(true);
      const timer = setTimeout(() => setIsTransitioning(false), 150);
      return () => clearTimeout(timer);
    }
  }, [items]);

  if (!items?.length) return null;

  return (
    <div
      ref={gridRef}
      className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 transition-opacity duration-150 ${
        isTransitioning ? 'opacity-95' : 'opacity-100'
      }`}
      style={{ contain: 'layout', willChange: 'auto' }}
    >
      {items.map((item: any, index: number) => {
        console.log('Passing onRemove to card for item:', item.id, 'onRemove function:', onRemove);
        return (
          <MemoUnifiedPortfolioCard
            key={item.id}
            item={item}
            index={index}
            onRemove={onRemove}
            onEdit={onEdit}
            onRename={onRename}
            onSetFeatured={onSetFeatured}
            onUpdateStatus={onUpdateStatus}
            onDuplicate={onDuplicate}
            onPreview={onPreview}
            sortOrder={sortOrder}
            isProcessing={isProcessing}
          />
        );
      })}
    </div>
  );
};

export default UnifiedPortfolioList;